// NewZipCodeModal.tsx
import React, { useState } from 'react';
import { db } from '../App';
import { doc, setDoc, collection, addDoc } from 'firebase/firestore'; // Import necessary Firestore functions
import { UserData } from './Types';
import './NewZipCodeModal.css';

interface NewZipCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
  updateAssignments: (user: UserData) => void;
}

const NewZipCodeModal: React.FC<NewZipCodeModalProps> = ({ isOpen, onClose }) => {
  const [newZipCode, setNewZipCode] = useState('');

  const handleAddZipCode = async () => {
    try {
      // Reference to the "ZipCodes" collection
      const zipCodesCollectionRef = collection(db, 'ZipCodes');
  
      // Data to be added to the document
      const data = {
        ZipCode: newZipCode,
      };
  
      // Add a new document with auto-generated ID to the "ZipCodes" collection
      await addDoc(zipCodesCollectionRef, data);
  
      console.log(`Zip code ${newZipCode} added successfully.`);
  
      // Close the modal after successfully adding the document
      onClose();
    } catch (error) {
      console.error('Error adding zip code:', error);
    }
  };

  return (
    <div className={`dispatch-modalN ${isOpen ? 'open' : ''}`}>
      <div className={`modal-overlayN ${isOpen ? 'open-overlay' : ''}`} onClick={onClose}></div>
      <div className={`modal-contentN ${isOpen ? 'open-content' : ''}`}>
        <h2 style={{marginTop:-30,width:210,textAlign:'center'}}>Add New Zip Code</h2>
        <input
  style={{ margin: '0 auto', display: 'block' }}
  type="text"
          placeholder="Enter Zip Code"
          value={newZipCode}
          onChange={(e) => setNewZipCode(e.target.value)}
        />
        <div style={{textAlign:'center',marginTop:20}}>
        <button onClick={handleAddZipCode} style={{ marginRight: '10px' }}>Add</button>
        <button onClick={onClose}>Cancel</button>
        </div>

      </div>
    </div>
  );
};

export default NewZipCodeModal;
